import React from "react";
import { useNavigate } from "react-router-dom";
import './OperationsPage.css';
import TopNav from "../components/TopNav";
import UtcClock from "../components/UtcClock";

// Static — defined at module scope so it is never recreated on re-render.
// Tours (id 17) is placed before Global Visas (id 16) so the 4-col
// bento grid auto-fills rows without leaving gaps.
const operationsCards = [
    {
        id: 1,
        title: "Jumpseat",
        description: "Instant crew relocation",
        link: "/jumpseat",
        size: "large",
        icon: "✈",
        code: "JMP"
    },
    {
        id: 2,
        title: "Charters",
        description: "View and manage charter flights",
        link: "/charter-view",
        size: "medium",
        icon: "◉",
        code: "CHT"
    },
    {
        id: 4,
        title: "CAT II / III",
        description: "All weather operations",
        link: "/awo",
        size: "medium",
        icon: "◎",
        code: "AWO"
    },
    {
        id: 5,
        title: "Roster",
        description: "Pilot roster & status",
        link: "/roster",
        size: "small",
        icon: "⊞",
        code: "RST"
    },
    {
        id: 7,
        title: "Documents",
        description: "Manuals & documentation",
        link: "/documents",
        size: "small",
        icon: "☰",
        code: "DOC"
    },
    {
        id: 8,
        title: "ACARS",
        description: "Aircraft communications & reporting",
        link: "/acars",
        size: "medium",
        icon: "⊙",
        code: "ACS"
    },
    {
        id: 9,
        title: "Community",
        description: "Engage with the pilot community",
        link: "/community",
        size: "large",
        icon: "⊕",
        code: "COM"
    },
    {
        id: 15,
        title: "Manual PIREP",
        description: "Submit manual pilot reports",
        link: "/manual-flight-report",
        size: "small",
        icon: "✏",
        code: "PIR"
    },
    {
        id: 17,
        title: "Tours",
        description: "Explore exciting destinations",
        link: "/tours",
        size: "small",
        icon: "◈",
        code: "TRS"
    },
    {
        id: 16,
        title: "Global Visas",
        description: "A showcase of world culture",
        link: "/visas",
        size: "medium",
        icon: "⊛",
        code: "VZA"
    }
];

const Operations = (props) => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />

            <div className={`dashboard-container ops-page ${props.darkmode ? 'dark-theme' : 'light-theme'}`}>
                <div className="ops-container">

                    {/* ── Header ───────────────────────────────────── */}
                    <header className="ops-header">
                        <div className="ops-header-left">
                            <div className="ops-live-badge">
                                <span className="live-dot"></span>
                                <span>LIVE</span>
                            </div>
                            <div className="ops-titles">
                                <h1 className="ops-title">Operations Center</h1>
                                <p className="ops-subtitle">FDX Virtual Airlines · Command & Control</p>
                            </div>
                        </div>

                        <div className="ops-header-right">
                            <div className="ops-status">
                                <div className="status-indicator">
                                    <span className="status-dot"></span>
                                    <span className="status-text">ALL SYSTEMS NOMINAL</span>
                                </div>
                            </div>
                            <UtcClock />
                        </div>
                    </header>

                    {/* ── Runway divider ───────────────────────────── */}
                    <div className="ops-divider" aria-hidden="true">
                        <span className="divider-end"></span>
                        <span className="divider-track"></span>
                        <span className="divider-end"></span>
                    </div>

                    {/* ── Bento Grid ───────────────────────────────── */}
                    <div className="bento-grid">
                        {operationsCards.map((card, index) => (
                            <div
                                key={card.id}
                                className={`bento-card card-${index + 1} size-${card.size}`}
                                onClick={() => navigate(card.link)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => e.key === 'Enter' && navigate(card.link)}
                                aria-label={`Open ${card.title}`}
                            >
                                <div className="card-accent-strip"></div>
                                <span className="card-code-badge">{card.code}</span>

                                <div className="card-body">
                                    <span className="card-icon" aria-hidden="true">{card.icon}</span>
                                    <h3 className="card-title">{card.title}</h3>
                                    <p className="card-description">{card.description}</p>
                                </div>

                                <div className="card-footer">
                                    <span className="card-cta">OPEN →</span>
                                </div>

                                <div className="card-pattern" aria-hidden="true"></div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </React.Fragment>
    );
};

export default Operations;
